(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => {
    root.querySelectorAll('[data-gl-detail-gallery]').forEach(gallery => {
      if(gallery.dataset.glDetailReady) return;
      const viewer=gallery.querySelector('[data-gallery-viewer]');
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumbnail]')];
      if(!viewer || thumbs.length<2) return;
      gallery.dataset.glDetailReady='true';
      const scroller=gallery.querySelector('[data-gallery-scroller]');
      const showSelected=()=>{
        const selected=thumbs.find(t=>t.dataset.gallerySelected==='true');
        if(!selected || !scroller) return;
        const a=selected.getBoundingClientRect(),b=scroller.getBoundingClientRect();
        if(a.left<b.left+3) scroller.scrollLeft-=b.left-a.left+6;
        else if(a.right>b.right-3) scroller.scrollLeft+=a.right-b.right+6;
      };
      viewer.addEventListener('click',event=>{
        const button=event.target.closest('[data-gl-detail-prev],[data-gl-detail-next]');
        if(!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const index=Math.max(0,thumbs.findIndex(t=>t.dataset.gallerySelected==='true'));
        const step=button.matches('[data-gl-detail-next]')?1:-1;
        thumbs[(index+step+thumbs.length)%thumbs.length].click();
      },true);
      gallery.querySelectorAll('[data-gl-detail-prev],[data-gl-detail-next]').forEach(b=>b.hidden=false);
      const observer=new MutationObserver(showSelected);
      thumbs.forEach(t=>observer.observe(t,{attributes:true,attributeFilter:['data-gallery-selected']}));
      const resize=new ResizeObserver(showSelected);
      if(scroller)resize.observe(scroller);
      const cleanup=event=>{
        if(event.target.contains(gallery)){observer.disconnect();resize.disconnect();document.removeEventListener('shopify:section:unload',cleanup);}
      };
      document.addEventListener('shopify:section:unload',cleanup);
      showSelected();
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
